import React, { Component, useRef, useState } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import 'moment/locale/pt-br'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faFilter, faFileAlt, faPen, faDollarSign } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { CHAVE_EMPRESA, NOME_EMPRESA } from '../../config'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Footer from '../../components/footer'
import ModalHistorico from '../../components/modalHistorico'

const estadoInicial = {
    name: '',
    tickets: [],
    loading: false,
    loadingPesquisa: false,
    redirect: false,
    pesquisa: '',
    status: -1,
    statusOptions: [
        { label: "Todos", value: -1 },
        { label: "Em digitação", value: 0 },
        { label: "Aguardando aprovação", value: 1 },
        { label: "Aprovado", value: 2 },
        { label: "Cancelado", value: 3 },
        { label: "Encerrado", value: 4 },
    ],
    lancamentos: [],
    historicosModal: false,
    empresaNome:'',

}

class Pedidos extends Component {

    constructor(props) {
        super(props);
        this.pdfExportComponent = React.createRef(null);
    }
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getTickets();
    }

    getTickets = async () => {
        if (this.props.id === 999999) {
            apiEmployee.get(`/tickets/ticketsCreditosEmpresas/${localStorage.getItem('empresaID')}`)
            .then(res => {this.setState({
                tickets: res.data,
                empresaNome: res.data[0].empresaNome,
            });
        })
        } else {
            apiEmployee.get(`/tickets/ticketsCreditos/${this.props.id}`)
                .then(res => this.setState({
                    tickets: res.data
                }))
        }
    }

    cancelTicket = (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <div>
                            <span>Deseja cancelar este ticket? (de {nome})</span>
                        </div>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    const ticket = this.state.tickets.find((t) => t.chave == id)

                                    if (ticket.status != 0) {
                                        await apiEmployee.delete(`tickets/cancelar/${id}`).then(
                                            async response => {
                                                if (response.data == true) {
                                                    document.location.reload()
                                                }
                                            },
                                            async response => {
                                                this.erroApi(response)
                                            }
                                        )
                                    } else {
                                        await apiEmployee.delete(`tickets/apagar/${id}`).then(
                                            async response => {
                                                if (response.data == true) {
                                                    document.location.reload()
                                                }
                                            },
                                            async response => {
                                                this.erroApi(response)
                                            }
                                        )
                                    }
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    pegarLancamentos = async (ticket) => {
        await apiEmployee.get(`/tickets/lancamentos/${ticket}`)
            .then(res => this.setState({
                lancamentos: res.data,
                historicosModal: true,
            }),
                err => console.error(err)
            ).catch(err => console.error(err))
    }

    filterItems = (item) => {
        if (this.state.status != -1 && this.state.status != 4) {
            return item.status == this.state.status;
        }
        else if (this.state.status == 4) {
            return item.saldo === 0;
        }

        return item.status != 3 && item.saldo > 0;
    }

    liberaTicket = async (id, empresa) => {
        const ticket = await apiEmployee.get(`/tickets/pegarticketid/${id}`)

        const lancamentoPayload = {
            empresa: ticket.data[0].empresa,
            data: moment().format('YYYY-MM-DD HH:mm:ss'),
            chave_pessoa: ticket.data[0].chave_pessoa,
            valor: ticket.data[0].valor,
            chave_unidade: ticket.data[0].chave_unidade,
            chave_ticket: ticket.data[0].chave,
            chave_usuario:0,
            chave_voucher: 1,
            tipo: 'LIBERACAO'
        }

        const saved = await apiEmployee.post(`/tickets/liberaticket/${id}`, {
            lancamentoPayload
        }).then((res) => res.data)
        .catch(err => null);

        if (saved) {
            window.location.reload();
        }
    }



    render() {

        return (
            <div className='page page-list'>
                <div
                    style={{
                        position: "absolute",
                        left: "-900000px",
                        top: 0,
                    }}
                >
                </div>
                {this.state.redirect &&
                    <Redirect to={'/'} />
                }
                {!this.state.loading &&
                    <div>
                        <ModalHistorico
                            lancamentos={this.state.lancamentos}
                            open={this.state.historicosModal}
                            onClose={(e) => this.setState({ historicosModal: e })}
                        />

                        <section>
                            <Header voltar />
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="page-breadcrumb">
                                        <h2 id='titulo'>Pedidos</h2>
                                    </div>
                                </div>
                            </div>

                        </section>

                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>

                            <Link to={{
                                pathname: `/addpedido/0`,
                                state: { os: undefined }
                            }} className='butaoadicionarcardapio add_button_big'>Fazer novo pedido</Link>

                            <div className='butaofiltros change_margin_mobile' onClick={(a) => this.setState({ expandido: !this.state.expandido })}> Filtrar  <FontAwesomeIcon icon={faFilter} size="12" color='black' /> </div>

                        </div>

                        <div className='add_button_fab'>
                            <Link to={{
                                pathname: `/addpedido/0`,
                                state: { os: undefined }
                            }}>
                                +
                            </Link>
                        </div>

                        {this.state.expandido &&
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 10 }}>
                                <div className='col-8' style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div className='col-2'></div>
                                    <div className='filter-field col-8 '>
                                        <span>Status:</span>
                                        <select className='select-filtro' value={this.state.status} onChange={(e) => this.setState({ status: e.currentTarget.value })}>
                                            {this.state.statusOptions.map((opt) => (
                                                <option value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='col-2'></div>
                                </div>
                            </div>
                        }

                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className='col-12 row'>
                                <div className='tickets_div'>
                                    {this.state.tickets.filter(this.filterItems).map((ticket, index) => {

                                        return (
                                            <div className='ticket_wrapper' key={ticket.chave}>
                                                <div className='ticket_header'>
                                                    <div className='ticket_titulos' style={{ flexGrow: 2 }}>
                                                        <div className='ticket_titulos_empresa'>{ticket.empresaNome}</div>
                                                        <div className='ticket_titulos_unidade'>{ticket.unidadeNome}</div>
                                                    </div>
                                                    <div className='ticket_titulos' style={{ flexGrow: 1 }}>
                                                        <div className='ticket_titulos_data'>{ticket.data && moment(ticket.data).isValid() ? moment(ticket.data).locale('pt-br').format("DD MMM") : ""}</div>
                                                        <div className='ticket_titulos_saldo'>
                                                            <span style={{ whiteSpace: 'nowrap' }}>
                                                                R$ {new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(ticket.saldo)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className='ticket_divider' />
                                                <div className='ticket_footer'>
                                                    <div className='ticket_footer_titulo'>{this.state.statusOptions.find((s) => ticket.status == s.value)?.label}</div>
                                                    <div className='ticket_footer_buttons'>
                                                        {ticket.status == 2 &&
                                                            <div className='ticket_footer_button'>
                                                                <FontAwesomeIcon
                                                                    title='Histórico'
                                                                    icon={faFileAlt}
                                                                    color={"#DE3338"}
                                                                    size={40}
                                                                    onClick={() => this.pegarLancamentos(ticket.chave)}
                                                                />
                                                            </div>
                                                        }
                                                        {(ticket.status == 0 || ticket.status == 1) &&
                                                            <div className='ticket_footer_button'>
                                                                <Link to={{
                                                                    pathname: `/addpedido/${ticket.chave}`,
                                                                    state: { ticket: { ...ticket } }
                                                                }}>
                                                                    <FontAwesomeIcon
                                                                        title="Editar"
                                                                        icon={faPen}
                                                                        color={"#DE3338"}
                                                                        size={40} />
                                                                </Link>
                                                            </div>
                                                        }
                                                        {ticket.status < 2 &&
                                                            <div className='ticket_footer_button'>
                                                                <FontAwesomeIcon
                                                                    title="Cancelar"
                                                                    icon={faTimes}
                                                                    color={"#DE3338"}
                                                                    onClick={() => this.cancelTicket(ticket.chave, ticket.unidadeNome)}
                                                                    size={40} />
                                                            </div>
                                                        }
                                                        {ticket.status < 2 && this.props.id === 999999 &&
                                                            <div className='ticket_footer_button'>
                                                                <FontAwesomeIcon
                                                                    title="Liberar"
                                                                    icon={faDollarSign}
                                                                    color={"#DE3338"}
                                                                    onClick={() => this.liberaTicket(ticket.chave, ticket.empresa)}
                                                                    size={40} />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div >
                            </div>
                        </div>

                    </div>
                }
                <Footer selected="PEDIDOS" />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Pedidos)
